import { render, staticRenderFns } from "./OrbitLoadingTransactionStep.vue?vue&type=template&id=11cbbe70&scoped=true"
import script from "./OrbitLoadingTransactionStep.vue?vue&type=script&lang=ts"
export * from "./OrbitLoadingTransactionStep.vue?vue&type=script&lang=ts"
import style0 from "./OrbitLoadingTransactionStep.vue?vue&type=style&index=0&id=11cbbe70&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11cbbe70",
  null
  
)

export default component.exports